<div class="balances-item flex flex-col sm:flex-row items-center cursor-pointer hover:bg-k-gray-disabled rounded-xl"
    (click)="itemClick()" [ngClass]="{'bg-k-gray-disabled':isFocus}">
    <img class="pr-1" [src]="data.image" />
    <div class="flex flex-nowrap">
        <span *ngIf="data.currency" class="label-currency ">{{data.currency}}:&nbsp; </span>
        <span [ngClass]="{'text-k-violet': data.balance==0, 'text-k-green':data.balance>0}">{{data.balance}}</span>
    </div>
</div>